import { DEFAULT_FONT_FAMILY } from 'common/constants';
import styled from 'styled-components';

interface IStyleProps {
  widthValue?: string;
}

export const Root = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  position: absolute;
  top: 113px;
  left: 53px;
  display: flex;
  z-index: 10;
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px rgba(189, 189, 189, 0.2);
`;

export const VerticalDivider = styled.div`
  width: 1px;
  flex: 1;
  margin: 25px 0px;
  background-color: rgba(189, 189, 189, 0.3);
`;

export const HorizontalDivider = styled.div`
  width: 85%;
  height: 1px;
  padding-right: 19px;
  background-color: rgba(189, 189, 189, 0.3);
`;

export const ColumnFilters = styled.div`
  width: ${(props: IStyleProps) => (props.widthValue ?? 'auto')};
`

export const FilterTitle = styled.div`
  font-weight: 500;
  margin-top: 14px;
  padding: 0px 19px;
`;

export const FilterList = styled.div`
  padding: 0px 19px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const CustomDate = styled.div`
  margin-top: 12px;
  padding: 0px 19px;
`;

export const CustomDateRow = styled.div`
  width: 153px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const CustomDateLabel = styled.div`
  font-size: 12px;
`;

export const CustomDateInput = styled.input`
  height: 25px;
  width: 107px;
  border-radius: 5px;
  border: solid 2px #e7e7ec;
  background-color: #fff;
  text-align: center;
`;

